import styled, { css } from 'styled-components';
import { IoIosArrowDown } from 'react-icons/io';
import { Button } from '@common/components';
import { StyledButton } from '../Button/styles';

export enum OpenState {
  HOVER = 'HOVER',
  CLICK = 'CLICK',
}

interface IInfoState {
  openState?: OpenState;
}

const clickStateStyles = css`
  color: ${({ theme }) => theme.elements.defaultWhite};
  background-color: ${({ theme }) => theme.elements.success};
  border: 1px solid ${({ theme }) => theme.elements.success};
`;

const hoverStateStyles = css`
  color: ${({ theme }) => theme.elements.textGrey};
  background-color: ${({ theme }) => theme.elements.defaultWhite};
  border: 1px solid ${({ theme }) => theme.elements.borderGrey};
`;

const OPEN_STATE_STYLES = {
  [OpenState.CLICK]: clickStateStyles,
  [OpenState.HOVER]: hoverStateStyles,
};

export const EmcPanelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100px;
  border: 2px solid ${({ theme }) => theme.elements.success};
  border-radius: 10px;
  padding: 8px;
  justify-content: center;
  align-items: center;
  position: relative;
`;

export const EmcPanelTitle = styled.span`
  color: ${({ theme }) => theme.elements.textGrey};
  font-weight: bold;
  font-size: ${({ theme }) => theme.elementFontSizes.default};
  margin-top: 12px;
`;

export const InfoWrapper = styled.div<IInfoState>`
  position: absolute;
  left: 35%;
  bottom: -65%;
  font-weight: bold;
  font-size: ${({ theme }) => theme.elementFontSizes.default};
  padding: 12px;
  border-radius: 4px;
  text-align: center;
  width: 180px;
  ${({ openState }) => openState && OPEN_STATE_STYLES[openState]};
`;

export const EmcLink = styled.div`
  display: flex;
  gap: 2px;
  align-items: center;
  cursor: pointer;
`;


export const Info = styled.div`
  color: ${({ theme }) => theme.elements.textGrey};
  display: flex;
  gap: 2px;
  align-items: center;
  font-weight: 600;
  width: 280px;
`;

export const InfoWrap = styled.div`
  width: 180px;
  display: flex;
  justify-content: flex-end;
  cursor: pointer;
  color: ${({ theme }) => theme.elements.textLightGrey};
  padding-left: 20px;
  margin: 0 10px 0 20px;
`;

export const ArrowIcon = styled(IoIosArrowDown).withConfig({
  shouldForwardProp: (prop) => !['isActive'].includes(prop),
})<{ isActive: boolean }>`
  color: ${({ theme }) => theme.elements.textGrey};
  margin-top: 3px;
  transition: all 0.2s ease-out;
  margin-left: 3px;
  ${({ isActive }) =>
    isActive &&
    css`
      transform: rotate(180deg);
    `}
`;

export const InfoPopoverWrap = styled.div`
  position: relative;
  color: ${({ theme }) => theme.elements.dropdownGrey};

  ${StyledButton} {
    width: 200px !important;
  }
`;

export const PopoverArrowWrap = styled.div`
  position: absolute;
  top: -9px;
  right: calc(50% - 5px);
  border-left: 10.5px solid transparent;
  border-right: 10.5px solid transparent;
  border-bottom: 10px solid ${({ theme }) => theme.colors.borderGray};
  width: 0;
  height: 0;
`;

export const PopoverArrow = styled.div`
  position: absolute;
  left: -10px;
  top: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid ${({ theme }) => theme.colors.defaultWhite};
  width: 0;
  height: 0;
`;

export const PopoverItem = styled.div`
  padding: 5px 10px;
  z-index: 1;
  text-align: center;
  &:last-child {
    border-bottom: none;
  }
`;

export const PopoverContent = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.borderGray};
  background-color: ${({ theme }) => theme.colors.defaultWhite};
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  border-radius: 4px;
  margin-right: 30px;
  margin-top: 15px;
  padding: 10px 10px;
`;

export const PopoverHeader = styled(PopoverItem)`
  text-align: center;
  font-weight: 600;
`;


export const QRCodeButton = styled(Button)`
`;